import React from 'react'
import { ListBulkActions } from '../../components'
import { ActionField } from '../../components/custom'
import { ROLE_ADMIN } from '../../utils/constants'

import {
  List,
  Datagrid,
  TextField,
  TextInput,
  Filter,
  FunctionField,
  ReferenceInput,
  AutocompleteInput,
  SelectInput,
} from 'react-admin'
import { formatSportKind, formatDate } from '../utils/format'
import { SportKindsOptions } from '../utils/helpers'

const UserFilters = (props) => (
  <Filter {...props}>
    {/* фильтрами по полям: Вид спорта, поиск по названию, период проведения */}
    <TextInput label='Название' source='name' />
    <TextInput label='ФИО' source='fullName' />
    {/*TODO доделать */}
    <ReferenceInput source='city' label='Город' reference='cities'>
      <AutocompleteInput optionText='name' />
    </ReferenceInput>
    <SelectInput
      label='Вид спорта'
      source='sportKind'
      choices={SportKindsOptions}
    />
  </Filter>
)

const ListTournaments = (props) => {
  return (
    <List
      title='Турниры'
      {...props}
      exporter={false}
      bulkActionButtons={<ListBulkActions />}
      filters={<UserFilters />}
    >
      <Datagrid rowClick={'show'}>
        <TextField source='name' label='Название' />
        <FunctionField
          label='Вид спорта'
          render={(record) => formatSportKind(record.sportKind)}
        />
        <TextField
          source='owner.fullName'
          label='Организатор'
          emptyText='Не указано'
        />
        <TextField source='city.name' label='Город' emptyText='Не указано' />
        <TextField source='place' label='Место' emptyText='Не указано' />
        <TextField source='address' label='Адрес' emptyText='Не указано' />
        <TextField
          source='owner.phone'
          label='Номер телефона'
          emptyText='Не указано'
        />
        <TextField
          source='participantsLimit'
          label='Максимальное кол-во регистраций'
          emptyText='Не указано'
        />
        <FunctionField
          label='Период проведения'
          render={(record) =>
            `C ${formatDate(record.dateStart)} по ${formatDate(record.dateEnd)}`
          }
        />
        {props.permissions === ROLE_ADMIN ? (
          <ActionField label='Действия' />
        ) : null}
      </Datagrid>
    </List>
  )
}

export default ListTournaments
